import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Icon, TextField, Box, Typography, Button } from "@mui/material";
import { DateRange } from "@mui/icons-material";
import moment from "moment-timezone";
import "moment/locale/id";
import axios from "axios";
import { API_URL } from "../api";
import "../css/MenuAbsensi.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { id } from "date-fns/locale";

export default function MenuAbsensiForeman() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [absensiData, setAbsensiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [userId, setUserId] = useState("");
  const [expandedCard, setExpandedCard] = useState(null);


  // Date Range State
  // Date Range State
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  // Temporary state for the picker (before clicking apply)
  const [tempDateRange, setTempDateRange] = useState(dateRange);
  const [tempStartDate, tempEndDate] = tempDateRange;
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  useEffect(() => {
    moment.locale("id");
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUserId(userData.nik || "");
      } catch (error) {
        console.error("Gagal mem-parsing data pengguna:", error);
        setUserId("");
      }
    }
  }, []);

  useEffect(() => {
    fetchAbsensiData();
  }, [userId]);

  // Filter Effect
  useEffect(() => {
    if (!startDate || !endDate) {
      setFilteredData(absensiData);
      return;
    }
    const filtered = absensiData.filter((item) => {
      const itemDate = new Date(item.tanggal);
      return (
        itemDate >= new Date(startDate.setHours(0, 0, 0, 0)) &&
        itemDate <= new Date(endDate.setHours(23, 59, 59, 999))
      );
    });
    setFilteredData(filtered);
  }, [dateRange, absensiData]);

  const fetchAbsensiData = async () => {
    if (!userId) {
      setLoading(false);
      setAbsensiData([]);
      setFilteredData([]);
      return;
    }
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/absensi?user_id=${userId}`);
      const data = response.data;
      setAbsensiData(Array.isArray(data) ? data : []);
      setFilteredData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Network error:", error);
      setAbsensiData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const formatDisplayDate = (date) => {
    if (!date) return "";
    return moment(date).format("DD MMM YYYY");
  };





  const toggleCardExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const renderAbsensiCard = (item, index) => {
    const isExpanded = expandedCard === index;
    const hari = moment.tz(item.tanggal, "Asia/Makassar").format("dddd");
    const tanggal = moment.tz(item.tanggal, "Asia/Makassar").format("LL");
    return (
      <div
        key={index}
        className="absensi-card"
        onClick={() => toggleCardExpand(index)}
      >
        <div className="card-container">
          <div className="card-header">
            <span className="day-text">
              {hari}, {tanggal}{" "}
            </span>
            <Icon className="expand-icon">
              {isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            </Icon>
          </div>
          <div className="card-body">
            <div className="info-row">
              <Icon className="info-icon">account_circle</Icon>
              <span className="info-text">{item.lokasi}</span>
            </div>
            <div className="info-row">
              <Icon className="info-icon">access_time</Icon>
              <span className="info-text">{item.jam}</span>
            </div>
          </div>
          {isExpanded && (
            <div className="expanded-content">
              <div className="detail-row">
                <Icon
                  className="detail-icon"
                  style={{
                    color: item.keterangan_sehat === "Iya" ? "green" : "red",
                  }}
                >
                  favorite
                </Icon>
                <span className="detail-text">
                  Keterangan Sehat: {item.keterangan_sehat}
                </span>
              </div>
              <div className="detail-row">
                <Icon
                  className="detail-icon"
                  style={{
                    color: item.konsumsi_obat === "Iya" ? "orange" : "gray",
                  }}
                >
                  medical_services
                </Icon>
                <span className="detail-text">
                  Konsumsi Obat: {item.konsumsi_obat}
                </span>
              </div>
              <div className="detail-row">
                <Icon className="detail-icon" style={{ color: "#4285F4" }}>
                  hotel
                </Icon>
                <span className="detail-text">
                  Jam Tidur: {item.jam_tidur || "-"} jam
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={id}>
      <div className="absensi-container">
        {/* Header */}
        <header className="app-header">
          <div className="header-content">
            <button className="back-button" onClick={() => navigate("/menu")}>
              <Icon>arrow_back</Icon>
            </button>
            <h1 className="header-title">Absensi P5M</h1>
            <div className="header-spacer"></div>
          </div>
        </header>

        <Box sx={{ px: 2, mb: 2 }}>
          <Box sx={{
            display: 'flex',
            mt: 2,
            alignItems: 'center',
            bgcolor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: 3,
            p: "12px 16px",
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            '&:hover': {
              borderColor: '#2196f3',
              boxShadow: '0 4px 12px rgba(33, 150, 243, 0.1)'
            }
          }} onClick={() => {
            setTempDateRange(dateRange);
            setIsDatePickerOpen(true);
          }}>
            <DateRange sx={{ color: '#2196f3', mr: 2 }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant="caption" sx={{ color: '#7f8c8d', display: 'block', lineHeight: 1 }}>
                Filter Tanggal
              </Typography>
              <Typography sx={{ fontSize: '0.95rem', fontWeight: 600, color: '#2c3e50', mt: 0.5 }}>
                {startDate && endDate
                  ? `${moment(startDate).format('DD MMM YYYY')} - ${moment(endDate).format('DD MMM YYYY')}`
                  : 'Pilih tanggal'}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* DatePicker Modal Overlay */}
        {isDatePickerOpen && (
          <Box sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }} onClick={() => setIsDatePickerOpen(false)}>
            <Box sx={{ bgcolor: 'white', borderRadius: 4, overflow: 'hidden', boxShadow: '0 16px 48px rgba(0,0,0,0.2)' }} onClick={(e) => e.stopPropagation()}>
              <DatePicker
                selectsRange={true}
                startDate={tempStartDate}
                endDate={tempEndDate}
                onChange={(update) => setTempDateRange(update)}
                inline
                monthsShown={1}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                yearDropdownItemNumber={5}
                scrollableYearDropdown
              />
              <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1, borderTop: '1px solid #eee', bgcolor: 'white' }}>
                <Button
                  size="small"
                  variant="outlined"
                  color="inherit"
                  onClick={() => setIsDatePickerOpen(false)}
                  sx={{ textTransform: 'none', borderRadius: 2 }}
                >
                  Batal
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setDateRange(tempDateRange);
                    setIsDatePickerOpen(false);
                  }}
                  sx={{ textTransform: 'none', borderRadius: 2, boxShadow: 'none' }}
                >
                  Terapkan
                </Button>
              </Box>
            </Box>
          </Box>
        )}

        <style>{`
            .date-range-input {
              border: none;
              outline: none;
              font-size: 0.95rem;
              font-weight: 600;
              color: #2c3e50;
              width: 100%;
              background: transparent;
              cursor: pointer;
              margin-top: 2px;
            }
            .react-datepicker-wrapper {
              width: 100%;
            }
            .react-datepicker {
              font-family: 'Inter', 'Segoe UI', sans-serif;
              border: none;
              border-radius: 16px;
              box-shadow: 0 10px 40px rgba(0,0,0,0.12);
              overflow: hidden;
              background: white;
              min-width: 300px;
            }
            .react-datepicker__header {
              background: #1976d2;
              border-bottom: none;
              padding: 16px 12px 12px;
              border-radius: 0;
            }
            .react-datepicker__current-month {
              display: none;
            }
            
            /* Month & Year Dropdown Container */
            .react-datepicker__header__dropdown {
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 8px;
              margin: 0;
              padding: 0 40px;
            }
            
            /* Dropdown Wrapper */
            .react-datepicker__month-dropdown-container,
            .react-datepicker__year-dropdown-container {
              position: relative;
            }
            
            /* Select Elements - Clean Simple Style */
            .react-datepicker__month-select,
            .react-datepicker__year-select {
              appearance: none;
              -webkit-appearance: none;
              -moz-appearance: none;
              background: transparent;
              border: none;
              outline: none;
              padding: 8px 24px 8px 8px;
              font-size: 1rem;
              font-weight: 600;
              color: white;
              cursor: pointer;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
              background-repeat: no-repeat;
              background-position: right 4px center;
              background-size: 14px;
            }
            
            .react-datepicker__month-select:focus,
            .react-datepicker__year-select:focus {
              outline: none;
            }
            
            /* Option styling */
            .react-datepicker__month-select option,
            .react-datepicker__year-select option {
              background: white;
              color: #2c3e50;
              padding: 8px;
              font-weight: 500;
            }
            
            /* Hide day names row */
            .react-datepicker__day-names {
              display: none;
            }
            
            .react-datepicker__month {
              padding: 12px;
              margin: 0;
              background: white;
            }
            
            .react-datepicker__day {
              width: 38px;
              line-height: 38px;
              margin: 2px;
              font-weight: 500;
              color: #2c3e50;
              font-size: 0.9rem;
              border-radius: 8px;
              transition: all 0.15s ease;
            }
            
            .react-datepicker__day:hover {
              background: #e3f2fd;
              border-radius: 8px;
            }
            
            .react-datepicker__day--outside-month {
              color: #bdc3c7;
            }
            
            .react-datepicker__day--disabled {
              color: #e0e0e0 !important;
            }
            
            /* Selected & Range States */
            .react-datepicker__day--selected,
            .react-datepicker__day--range-end,
            .react-datepicker__day--range-start {
              background: #1976d2 !important;
              color: white !important;
              border-radius: 8px !important;
              font-weight: 600;
            }
            
            .react-datepicker__day--in-range {
              background: #e3f2fd !important;
              color: #1976d2 !important;
              border-radius: 0 !important;
            }
            
            .react-datepicker__day--in-selecting-range {
              background: #bbdefb !important;
              color: #1976d2 !important;
            }
            
            .react-datepicker__day--range-start {
              border-top-right-radius: 0 !important;
              border-bottom-right-radius: 0 !important;
            }
            
            .react-datepicker__day--range-end {
              border-top-left-radius: 0 !important;
              border-bottom-left-radius: 0 !important;
            }
            
            /* Navigation Arrows */
            .react-datepicker__navigation {
              top: 14px;
              width: 28px;
              height: 28px;
              background: transparent;
              border-radius: 6px;
              transition: all 0.15s ease;
            }
            
            .react-datepicker__navigation:hover {
              background: rgba(255,255,255,0.2);
            }
            
            .react-datepicker__navigation--previous {
              left: 8px;
            }
            
            .react-datepicker__navigation--next {
              right: 8px;
            }
            
            .react-datepicker__navigation-icon::before {
              border-color: white;
              border-width: 2px 2px 0 0;
              width: 8px;
              height: 8px;
            }
            
            .react-datepicker__triangle {
              display: none;
            }
            
            /* Today Highlight */
            .react-datepicker__day--today {
              background: #f5f5f5;
              font-weight: 700;
              color: #1976d2;
            }
            
            /* Keyboard Selected */
            .react-datepicker__day--keyboard-selected {
              background: #e3f2fd;
              color: #1976d2;
            }
            
            /* Close button */
            .react-datepicker__close-icon {
              display: none;
            }
            
            /* Animation */
            @keyframes fadeIn {
              from { opacity: 0; transform: scale(0.95); }
              to { opacity: 1; transform: scale(1); }
            }
            
            .react-datepicker {
              animation: fadeIn 0.15s ease-out;
            }
          `}</style>

        {/* Main Content */}
        <main className="absensi-content">
          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <div className="absensi-list">
              {filteredData.length > 0 ? (
                filteredData.map((item, index) =>
                  renderAbsensiCard(item, index)
                )
              ) : (
                <div className="empty-container">
                  <Icon className="empty-icon">info</Icon>
                  <p className="empty-text">
                    {startDate && endDate
                      ? "Tidak ada data pada range tanggal ini"
                      : "Belum ada data absensi"}
                  </p>
                  {startDate && endDate && (
                    <button className="reset-text" onClick={() => setDateRange([null, null])}>
                      Reset filter
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </main>

        {/* Speed Dial/FAB */}
        <div className={`speed-dial ${open ? "open" : ""}`}>
          <button
            className="speed-dial-button"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
          >
            <Icon>{open ? "close" : "edit"}</Icon>
          </button>
          {open && (
            <div className="speed-dial-content">
              <div className="speed-dial-note">
                <p>
                  Materi safety cukup diisi oleh satu orang dari masing-masing
                  tim
                </p>
              </div>
              <div className="speed-dial-actions">
                <button
                  className="speed-dial-action"
                  onClick={() => navigate("/absensi-materi-safety")}
                >
                  <Icon>add</Icon>
                  <span>Materi Safety P5M</span>
                </button>
                <button
                  className="speed-dial-action"
                  onClick={() => navigate("/absensi-hadir-p5m")}
                >
                  <Icon>add</Icon>
                  <span>Absen Hadir P5M</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </LocalizationProvider>
  );
}
